import React, { Fragment, useState } from "react";
import PersonSearch from "./PersonSearch/PersonSearch";
import AddPersonModal from "./AddPersonModal";
import { useBool } from "@sg-core/index"
import { IPerson } from "../../models/IPerson";
import EditPersonModal from "./EditPersonModal";

export type TPickerValue = number | number[] | null | undefined;


export interface PersonPickerProps {
    value?: TPickerValue;
    onChange: (value: TPickerValue) => void;
    isMulti?: boolean;
    requiredCerts?: Array<string>;
    inputForCertStartDate?: boolean;
    excludeUncertified?: boolean;
};

const PersonPicker: React.FC<PersonPickerProps> = ({
    value,
    onChange,
    isMulti,
    requiredCerts = [],
    inputForCertStartDate = true,
    excludeUncertified = false
}) => {

    const [creatingModal, showAddPerson, hideAddPerson] = useBool();
    const [personOnEdit, setPersonOnEdit] = useState<IPerson | null>(null);

    const handleNewPerson = (person: IPerson) => {
        if (isMulti) {
            onChange([...Array.isArray(value) ? value : [], person.id]);
        } else {
            onChange(person.id)
        }
        hideAddPerson();
    };

    const permissions = {
        update: true,
        create: true
    };


    return (
        <Fragment>

            <PersonSearch
                style={{ width: "100%" }}
                value={value}
                onChange={onChange}
                isMulti={isMulti}
                onAddPerson={permissions.create ? showAddPerson : undefined}
                onEditPerson={permissions.update ? setPersonOnEdit : undefined}
                requiredCerts={requiredCerts}
                excludeUncertified={excludeUncertified}
            />
            {creatingModal && (
                <AddPersonModal
                    open={creatingModal}
                    onSuccess={handleNewPerson}
                    onCancel={hideAddPerson}
                    requiredCerts={requiredCerts}
                    inputForCertStartDate={inputForCertStartDate}
                />
            )}

            {personOnEdit && (
                <EditPersonModal
                    person={personOnEdit}
                    open={Boolean(personOnEdit)}
                    onSuccess={() => setPersonOnEdit(null)}
                    onCancel={() => setPersonOnEdit(null)}
                    requiredCerts={requiredCerts}
                    inputForCertStartDate={inputForCertStartDate}
                />
            )}
        </Fragment>
    );
};


export default PersonPicker;
